import 'firebase/compat/auth'
import 'firebase/compat/database'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'
import 'firebase/compat/functions'

import { configureStore } from '@reduxjs/toolkit'
import firebase from 'firebase/compat/app'
import { Provider } from 'react-redux'
import { firebaseReducer, ReactReduxFirebaseProvider } from 'react-redux-firebase'
import { createFirestoreInstance, firestoreReducer } from 'redux-firestore' // <- needed if using firestore

import { firebaseConfig, FIRESTORE_STORAGE_URL } from './config'
import { initialState as preferencesInitialState, preferencesReducer } from './preferences'

const rrfConfig = {
  userProfile: 'users',
  useFirestoreForProfile: false,
  enableLogging: false,
  storageBucket: FIRESTORE_STORAGE_URL
}

firebase.initializeApp(firebaseConfig)
firebase.firestore()
firebase.storage()
firebase.functions()

const store = configureStore({
  reducer: {
    firebase: firebaseReducer,
    firestore: firestoreReducer,
    preferences: preferencesReducer
  },
  preloadedState: {
    preferences: preferencesInitialState
  },
  // TODO: This is not recommended, but firestore has a whole bunch of timestamp objects that aren't serializable which creates a lot of noise
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false
    })
})

const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance,
  // React 19 ignores defaultProps on function components; RRF relies on
  // default initializeAuth=true. Without this, auth init never runs (isLoaded stays false).
  initializeAuth: true
}

export const FirebaseProvider = ({ children }) => {
  return (
    <Provider store={store}>
      <ReactReduxFirebaseProvider {...rrfProps}>{children}</ReactReduxFirebaseProvider>
    </Provider>
  )
}
